import { Button } from "react-admin";

export default function CustomButtonCancel({ ...props }) {
  const { onClick, label } = props;
  return (
    <Button
      label={label ? label : "Cancel"}
      variant="contained"
      size="medium"
      sx={{
        width: "120px",
        // color: "#e9fce7",
        // bgcolor: "#75899d",
        color: "#1976d2",
        bgcolor: "#e0e0e0",
        "&:hover": {
          // bgcolor: "gray"
          bgcolor: "#f5f5f5",
        },
      }}
      onClick={onClick}
    />
  );
}
